import * as React from 'react';
import { Divider, type DividerProps } from '@fluentui/react-components';

export type SeparatorProps = DividerProps;

export const Separator: React.FC<SeparatorProps> = (props) => <Divider {...props} />;


